// Canonical Rupora APK source of truth. The endpoint path intentionally
// contains "pega-pay" — it is the existing backend route that serves the
// official Rupora APK. Do NOT rename or replace it.
// Browsers never call this cross-origin URL directly: every download button
// uses the same-origin streaming route below for reliable file downloads.
export const RUPORA_APK_DOWNLOAD_URL =
  "https://awadhcrypto.in/api/public/exchange/pega-pay/download-apk";

// Same-origin route (streams RUPORA_APK_DOWNLOAD_URL server-side via the
// backend, so it works identically in preview and production builds).
// All landing-page download buttons must use this path.
export const RUPORA_DOWNLOAD_ROUTE = "/api/download-app";
